// extracted by mini-css-extract-plugin
module.exports = {"EventSubmissionPage__Main":"EventSubmissionPage_EventSubmissionPage__Main__am26J","EventSubmissionPage":"EventSubmissionPage_EventSubmissionPage__2XZOJ"};